<app-header></app-header>
<app-navbar [selected]="'administration'"></app-navbar>

<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">
        <div class="row">
            <div class="col-md-6 fw-bold">
                <label for="basic-url" class="form-label color-text"> {{ 'sidebar.cancellation' | translate }}
                </label>
            </div>
            <div class="col-md-6 text-end">
                <button type="button" class="btn custombutton" (click)="checkRow()">{{ 'buttons.add' |
                    translate}}</button>
            </div>
        </div>
        @if (this.cancellationReponse.enrollmentCancellationDto &&
        this.cancellationReponse.enrollmentCancellationDto.length > 0) {
        <div>
            <fieldset>
                <table class="table text-center mt-2" role="table"
                    [attr.aria-label]="'sidebar.cancellation' | translate">
                    <thead role="rowgroup">
                        <tr role="row">
                            <th scope="col" role="columnheader">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col" role="columnheader">{{ 'model.code' | translate }}</th>
                            <th scope="col" role="columnheader">{{ 'tariffRole.descripcion' | translate }}</th>
                            <th scope="col" role="columnheader">{{ 'tariffUsers.checkActive' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody role="rowgroup">
                        <tr *ngFor="let cancellation of this.cancellationReponse.enrollmentCancellationDto; let i = index"
                            [ngClass]="{'resaltado': selectedRowId === cancellation.idEnrollmentCancellationPattern}"
                            role="row">
                            <td role="cell">
                                <input type="radio" id="flexRadioDefault{{i}}" name="flexRadioDefault"
                                    [checked]="selectedRowId === cancellation.idEnrollmentCancellationPattern"
                                    (click)="checkRow(cancellation)" />
                                <label [for]="'flexRadioDefault' + i" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'model.code' | translate }} {{ cancellation.codeCancellation }},
                                    {{ 'tariffRole.descripcion' | translate }} {{ cancellation.shortDescription }},
                                    {{ 'tariffUsers.checkActive' | translate }} {{ cancellation.active === 'S' ?
                                    ('model.active' | translate) : ('model.inactive' | translate) }}
                                </label>
                            </td>
                            <td role="cell"><span>{{ cancellation.codeCancellation }}</span></td>
                            <td role="cell"><span>{{ cancellation.shortDescription }}</span></td>
                            <td role="cell">
                                <span>{{ cancellation.active === 'S' ? ('model.active' | translate) : ('model.inactive'
                                    |
                                    translate) }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <div class="mt-2" *ngIf="this.cancellationReponse.pageDto">
                <app-paginator [isStart]="this.cancellationReponse.pageDto.start"
                    [isEnd]="this.cancellationReponse.pageDto.end"
                    [currentPage]="this.cancellationReponse.pageDto.currentPage"
                    [totalPages]="this.cancellationReponse.pageDto.pages"
                    [numberRecord]="this.cancellationReponse.pageDto.records"
                    [sizePage]="this.cancellationReponse.pageDto.pageSize">
                </app-paginator>
            </div>

        </div>
        }
        @if (this.selectedRowId || isCreate) {
        <div class="separator mt-5"></div>

        <div>
            <form [formGroup]="cancellationForm" (ngSubmit)="createOrUpdateCancellation()">
                <div class="mt-5">
                    @if(!this.selectedRowId){
                    <h2 class="textformat mb-4 color-text">{{ 'enrollment.create' |
                        translate }}</h2>
                    }@else {
                    <h2 class="textformat mb-4 color-text">{{ 'enrollment.editat' |
                        translate }}</h2>
                    }
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="codeCancellation">{{ 'enrollment.codi' | translate }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="codeCancellation" name="codeCancellation"
                            required formControlName="codeCancellation">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="shortDescription">{{ 'enrollment.description' | translate
                            }}<span>
                                *</span></label>
                        <input type="text" class="form-control color-text" id="shortDescription" name="shortDescription"
                            required formControlName="shortDescription">
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="typology">{{ 'catalog.type' | translate }}<span>
                                *</span></label>
                        <select id="typology" name="typology" class="form-select" aria-label="typology"
                            formControlName="typology">
                            <option value=""></option>
                            <option value="O">{{'serviceType.O' | translate}}</option>
                            <option value="P">{{'serviceType.P' | translate}}</option>
                        </select>
                    </div>
                    <div class="col-6 mb-3">
                        <label for="active">{{ 'model.status' | translate}}<span>
                                *</span></label>
                        <select class="form-select mt-2" formControlName="active" id="active" name="active">
                            <option value="S">{{ 'model.active' | translate }}</option>
                            <option value="N">{{ 'model.inactive' | translate }}</option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="descriptionCas" class="form-label">{{ 'model.descriptionCast' | translate }}<span>
                                *</span></label>
                        <textarea type="text" class="form-control color-text" id="descriptionCas" name="descriptionCas"
                            required formControlName="descriptionCas"></textarea>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionCat" class="form-label">{{ 'model.descriptionCat' | translate }}<span>
                                *</span></label>
                        <textarea type="text" class="form-control color-text" id="descriptionCat" name="descriptionCat"
                            required formControlName="descriptionCat"></textarea>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label for="descriptionEng" class="form-label">{{ 'model.descriptionEng' | translate }}<span>
                                *</span></label>
                        <textarea type="text" class="form-control color-text" id="descriptionEng" name="descriptionEng"
                            required formControlName="descriptionEng"></textarea>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="academicFee">{{ 'enrollment.academicas' | translate }}<span>
                                *</span></label>
                        <select id="academicFee" name="academicFee" class="form-select" aria-label="academicFee"
                            formControlName="academicFee">
                            <option value="T">{{'T' | translate}}</option>
                            <option value="F">{{'F' | translate}}</option>
                            <option value="P">{{'P' | translate}}</option>
                            <option value="N">{{'N' | translate}}</option>
                        </select>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="administrativeFee">{{ 'enrollment.administrativas' | translate
                            }}<span>
                                *</span></label>
                        <select id="administrativeFee" name="administrativeFee" class="form-select"
                            aria-label="administrativeFee" formControlName="administrativeFee">
                            <option value="T">{{'TA' | translate}}</option>
                            <option value="N">{{'NA' | translate}}</option>
                        </select>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="resourceRate">{{ 'enrollment.aprendizaje' | translate }}<span>
                                *</span></label>
                        <select id="resourceRate" name="resourceRate" class="form-select" aria-label="resourceRate"
                            formControlName="resourceRate">
                            <option value="T">{{'T' | translate}}</option>
                            <option value="F">{{'F' | translate}}</option>
                            <option value="P">{{'P' | translate}}</option>
                            <option value="N">{{'N' | translate}}</option>
                        </select>
                    </div>

                    <div class="col-md-6 mb-3">
                        <label class="form-label" for="surcharge">{{ 'enrollment.recargos' | translate }}<span>
                                *</span></label>
                        <select id="surcharge" name="surcharge" class="form-select" aria-label="surcharge"
                            formControlName="surcharge">
                            <option value="T">{{'TR' | translate}}</option>
                            <option value="N">{{'NR' | translate}}</option>
                        </select>
                    </div>

                    <div class="col-md-6 mb-3">
                        <input class="form-check-input mx-3" type="checkbox" id="additionalCancellationFee"
                            name="additionalCancellationFee" formControlName="additionalCancellationFee">
                        <label class="form-check-label color-text" for="additionalCancellationFee">
                            {{ 'enrollment.aplicar' | translate }}
                        </label>
                    </div>
                </div>
                <button type="button" class="btn cancelbutton mt-3" (click)="selectedRowId = null; ; isCreate = false">
                    {{ 'administrativeTaxes.cancel' | translate }}
                </button>
                @if(!this.selectedRowId){
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'enrollment.create' | translate
                    }}</button>
                }@else {
                <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'enrollment.editat' | translate
                    }}</button>
                }

            </form>
        </div>
        }
        <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
            [message]="errorMessage"
            (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
    </main>
</div>